// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3181":"3af5b1309a304dcc","5798":"12168a13e6ebad21"}[chunkId] + ".css";
};